import { render, staticRenderFns } from "./ListasIndex.vue?vue&type=template&id=80cf1982&"
import script from "./ListasIndex.vue?vue&type=script&lang=js&"
export * from "./ListasIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports